(function () {
  'use strict';

  if (window.TaraConsultationMonitoring) return;

  var pendingInits = Array.isArray(window.__taraConsultationMonitoringBootQueue)
    ? window.__taraConsultationMonitoringBootQueue
    : [];
  var pendingEvents = [];
  var maxPendingEvents = 50;
  var state = {
    initialized: false,
    initConfig: null,
  };
  var EMAIL_PATTERN = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi;
  var PHONE_PATTERN = /\+?\d[\d\s().-]{7,}\d/g;

  function normalizeString(value, maxLength) {
    var normalized = typeof value === 'string' ? value.trim() : String(value || '').trim();
    if (!normalized) return '';
    return normalized.slice(0, maxLength || 200);
  }

  function redactString(value, maxLength) {
    var normalized = normalizeString(value, maxLength);
    if (!normalized) return '';
    return normalized
      .replace(EMAIL_PATTERN, '[redacted-email]')
      .replace(PHONE_PATTERN, '[redacted-phone]');
  }

  function toFiniteNumber(value) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function getSentry() {
    return window.Sentry && typeof window.Sentry.captureException === 'function'
      ? window.Sentry
      : null;
  }

  function applyScope(scope, meta) {
    if (!scope || !meta || typeof meta !== 'object') return;

    var baseTags = state.initConfig && state.initConfig.tags && typeof state.initConfig.tags === 'object'
      ? state.initConfig.tags
      : {};
    var tags = meta.tags && typeof meta.tags === 'object' ? meta.tags : {};

    Object.keys(baseTags).concat(Object.keys(tags)).forEach(function (key) {
      var normalizedKey = normalizeString(key, 80);
      var normalizedValue = redactString(tags[key] != null ? tags[key] : baseTags[key], 120);
      if (!normalizedKey || !normalizedValue) return;
      scope.setTag(normalizedKey, normalizedValue);
    });

    if (meta.error_code) scope.setTag('error_code', redactString(meta.error_code, 120));
    if (meta.route) scope.setTag('route', redactString(meta.route, 120));
    if (meta.level) scope.setLevel(normalizeString(meta.level, 20));

    if (Array.isArray(meta.fingerprint) && meta.fingerprint.length) {
      scope.setFingerprint(meta.fingerprint.map(function (value) {
        return normalizeString(value, 160);
      }).filter(Boolean));
    }

    var contexts = meta.contexts && typeof meta.contexts === 'object' ? meta.contexts : {};
    Object.keys(contexts).forEach(function (key) {
      if (!contexts[key] || typeof contexts[key] !== 'object') return;
      scope.setContext(normalizeString(key, 80), contexts[key]);
    });

    var extras = meta.extra && typeof meta.extra === 'object' ? meta.extra : {};
    if (meta.status_code != null) extras.status_code = meta.status_code;
    if (meta.request_duration_ms != null) extras.request_duration_ms = meta.request_duration_ms;
    if (meta.target_duration_ms != null) extras.target_duration_ms = meta.target_duration_ms;

    Object.keys(extras).forEach(function (key) {
      var value = extras[key];
      var normalizedKey = normalizeString(key, 80);
      if (!normalizedKey || value == null || value === '') return;
      scope.setExtra(normalizedKey, typeof value === 'string' ? redactString(value, 400) : value);
    });
  }

  function sanitizeEvent(event) {
    if (!event || typeof event !== 'object') return event;

    if (event.user) delete event.user;

    if (typeof event.message === 'string') {
      event.message = redactString(event.message, 400);
    }

    if (event.exception && Array.isArray(event.exception.values)) {
      event.exception.values = event.exception.values.map(function (item) {
        if (!item || typeof item !== 'object') return item;
        var nextItem = Object.assign({}, item);
        if (typeof nextItem.value === 'string') {
          nextItem.value = redactString(nextItem.value, 500);
        }
        return nextItem;
      });
    }

    if (event.tags && typeof event.tags === 'object') {
      Object.keys(event.tags).forEach(function (key) {
        if (typeof event.tags[key] === 'string') {
          event.tags[key] = redactString(event.tags[key], 120);
        }
      });
    }

    if (event.extra && typeof event.extra === 'object') {
      Object.keys(event.extra).forEach(function (key) {
        if (typeof event.extra[key] === 'string') {
          event.extra[key] = redactString(event.extra[key], 400);
        }
      });
    }

    if (Array.isArray(event.breadcrumbs)) {
      event.breadcrumbs = event.breadcrumbs.map(function (crumb) {
        if (!crumb || typeof crumb !== 'object') return crumb;
        var nextCrumb = Object.assign({}, crumb);
        if (typeof nextCrumb.message === 'string') {
          nextCrumb.message = redactString(nextCrumb.message, 240);
        }
        if (nextCrumb.data && typeof nextCrumb.data === 'object') {
          Object.keys(nextCrumb.data).forEach(function (key) {
            if (typeof nextCrumb.data[key] === 'string') {
              nextCrumb.data[key] = redactString(nextCrumb.data[key], 240);
            }
          });
        }
        return nextCrumb;
      });
    }

    return event;
  }

  function getExceptionValues(event) {
    return event
      && event.exception
      && Array.isArray(event.exception.values)
      ? event.exception.values
      : [];
  }

  function collectEventText(event, hint) {
    var parts = [];
    if (event && typeof event.message === 'string') parts.push(event.message);
    if (event && typeof event.culprit === 'string') parts.push(event.culprit);
    if (event && typeof event.transaction === 'string') parts.push(event.transaction);
    if (event && event.request && typeof event.request.url === 'string') parts.push(event.request.url);

    getExceptionValues(event).forEach(function (item) {
      if (!item || typeof item !== 'object') return;
      if (typeof item.type === 'string') parts.push(item.type);
      if (typeof item.value === 'string') parts.push(item.value);
      var frames = item.stacktrace && Array.isArray(item.stacktrace.frames)
        ? item.stacktrace.frames
        : [];
      frames.forEach(function (frame) {
        if (!frame || typeof frame !== 'object') return;
        if (typeof frame.filename === 'string') parts.push(frame.filename);
        if (typeof frame.function === 'string') parts.push(frame.function);
        if (typeof frame.module === 'string') parts.push(frame.module);
      });
    });

    var original = hint && hint.originalException;
    if (original) {
      if (typeof original === 'string') {
        parts.push(original);
      } else {
        if (typeof original.message === 'string') parts.push(original.message);
        if (typeof original.stack === 'string') parts.push(original.stack);
        if (typeof original.name === 'string') parts.push(original.name);
      }
    }

    return parts.join('\n').toLowerCase();
  }

  function shouldDropExternalNoise(event, hint) {
    var text = collectEventText(event, hint);
    if (!text) return false;

    return text.indexOf('otlp-http-production.shopifysvc.com') !== -1
      || text.indexOf('shopifycloud/shop-js') !== -1
      || text.indexOf('iabjs://') !== -1
      || text.indexOf('enabledidusertypeonkeyboardlogging') !== -1
      || text.indexOf('java object is gone') !== -1
      || text.indexOf('window.webkit.messagehandlers') !== -1;
  }

  function sendEvent(event) {
    var sentry = getSentry();
    if (!state.initialized || !sentry) {
      if (pendingEvents.length >= maxPendingEvents) pendingEvents.shift();
      pendingEvents.push(event);
      return;
    }

    sentry.withScope(function (scope) {
      applyScope(scope, event.meta || {});
      if (event.kind === 'exception') {
        sentry.captureException(event.error || new Error(event.message || 'Unknown consultation error'));
        return;
      }
      sentry.captureMessage(normalizeString(event.message, 240) || 'Consultation event', (event.meta && event.meta.level) || 'info');
    });
  }

  function flushPendingEvents() {
    if (!state.initialized || !getSentry()) return;
    while (pendingEvents.length) {
      sendEvent(pendingEvents.shift());
    }
  }

  function init(config) {
    if (state.initialized) return true;

    var sentry = getSentry();
    if (!sentry || typeof sentry.init !== 'function' || !config || !config.dsn) return false;

    sentry.init({
      dsn: config.dsn,
      environment: normalizeString(config.environment, 80) || 'production',
      release: normalizeString(config.release, 120) || undefined,
      sampleRate: toFiniteNumber(config.sampleRate) || 1,
      sendDefaultPii: false,
      maxBreadcrumbs: 30,
      ignoreErrors: [
        /otlp-http-production\.shopifysvc\.com/i,
        /enableDidUserTypeOnKeyboardLogging/i,
        /Java object is gone/i,
        /window\.webkit\.messageHandlers/i,
      ],
      beforeSend: function (event, hint) {
        if (shouldDropExternalNoise(event, hint)) return null;
        return sanitizeEvent(event);
      },
    });

    state.initialized = true;
    state.initConfig = {
      tags: config.tags && typeof config.tags === 'object' ? config.tags : {},
    };

    flushPendingEvents();
    return true;
  }

  function captureException(error, meta) {
    sendEvent({
      kind: 'exception',
      error: error,
      meta: meta || {},
    });
  }

  function captureMessage(message, meta) {
    sendEvent({
      kind: 'message',
      message: message,
      meta: meta || {},
    });
  }

  function addBreadcrumb(message, data, level) {
    var sentry = getSentry();
    if (!state.initialized || !sentry || typeof sentry.addBreadcrumb !== 'function') return;

    sentry.addBreadcrumb({
      category: 'tara.consultation',
      message: redactString(message, 240),
      data: data && typeof data === 'object' ? data : undefined,
      level: normalizeString(level, 20) || 'info',
      timestamp: Date.now() / 1000,
    });
  }

  function startTimer(name, meta) {
    var startedAt = Date.now();
    var startedAtPerf = window.performance && typeof window.performance.now === 'function'
      ? window.performance.now()
      : null;

    return function finish(resultMeta) {
      var completedAt = startedAtPerf != null && window.performance && typeof window.performance.now === 'function'
        ? window.performance.now()
        : Date.now();
      var duration = startedAtPerf != null
        ? Math.max(Math.round(completedAt - startedAtPerf), 0)
        : Math.max(Date.now() - startedAt, 0);
      var metaConfig = meta && typeof meta === 'object' ? meta : {};
      var resultConfig = resultMeta && typeof resultMeta === 'object' ? resultMeta : {};
      var threshold = toFiniteNumber(resultConfig.slow_threshold_ms != null ? resultConfig.slow_threshold_ms : metaConfig.slow_threshold_ms);

      if (threshold && duration >= threshold && !resultConfig.skip_slow_report) {
        captureMessage((normalizeString(name, 120) || 'consultation_request') + ' exceeded latency target', {
          level: 'warning',
          route: resultConfig.route || metaConfig.route,
          error_code: resultConfig.error_code || metaConfig.error_code || 'latency_target_exceeded',
          fingerprint: resultConfig.fingerprint || metaConfig.fingerprint,
          tags: Object.assign({}, metaConfig.tags || {}, resultConfig.tags || {}, {
            metric: 'consultation_latency',
            operation: normalizeString(name, 120) || 'consultation_request',
          }),
          extra: Object.assign({}, metaConfig.extra || {}, resultConfig.extra || {}, {
            request_duration_ms: duration,
            target_duration_ms: threshold,
            started_at: new Date(startedAt).toISOString(),
          }),
          status_code: resultConfig.status_code != null ? resultConfig.status_code : metaConfig.status_code,
        });
      }

      return duration;
    };
  }

  window.TaraConsultationMonitoring = {
    init: init,
    captureException: captureException,
    captureMessage: captureMessage,
    addBreadcrumb: addBreadcrumb,
    startTimer: startTimer,
  };

  while (pendingInits.length) {
    try {
      init(pendingInits.shift());
    } catch (error) {
      console.warn('[Tara Consultation] Monitoring init failed:', error);
    }
  }
})();
